module.exports = __webpack_public_path__ + "img/car_black.0073900b.svg";